import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { ModuleConfiguration } from '../security.module.config';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as workspaceActions from '../../pillar/workspace/store/actions';
import { Observable } from 'rxjs/Observable';
import { ResponseMessageType } from '../../core/services/ResponseMessageType';
import { SupportTicketService } from './SupportTicketService';
import * as supportTicketActions from '../store/actions';
import { HttpErrorResponse } from '@angular/common/http';
import { ModelResponse } from '../../core/services/ModelResponse';
import { SupportTicketInformationModel } from '../models/SupportTicketInformationModel';
import { SupportTicketModel } from '../models/SupportTicketModel';
import { ActionError } from '../../pillar/common/actions/ActionError';
import { ActivateDraftMessageToUsersAction } from '../store/actions';

@Injectable()
export class SupportTicketServiceEffects {
  onlyOnce = true;
  @Effect()
  getSupportTicketInformation$: Observable<Action> = this.actions$.ofType(supportTicketActions.GET_SUPPORT_TICKET_INFORMATION_ACTION)
      .switchMap((action: supportTicketActions.GetSupportTicketInformationAction) => this.supportTicketService.getSupportTicketInformation()
        .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<SupportTicketInformationModel>(error)))
        .map((response: ModelResponse<SupportTicketInformationModel>) => {
        if (response.hasError) {
          return new ActionError(action, response.messages.map(m => m.value));
        }
          return new supportTicketActions.GetSupportTicketInformationSuccessAction({ supportTicketInformation: response.model });
      }));

  @Effect()
  reviseSupportTicketEmail$: Observable<Action> = this.actions$.ofType(workspaceActions.updateModelType(ModuleConfiguration.moduleName, SupportTicketInformationModel, 'supportTicketEmailAddress'))
      .switchMap((action: workspaceActions.UpdateModelAction<SupportTicketInformationModel, string>) => this.supportTicketService.reviseSupportTicketEmail(action.payload.key, action.payload.model)
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<string>(error)))
      .map((response: ModelResponse<string>) => {
        if (response.hasError) {
          return new workspaceActions.UpdateModelErrorAction(
            {
              action: action,
              errors: response.messages.filter(m => m.type === ResponseMessageType.Error).map(m => m.value)
            });
        }
        return new workspaceActions.UpdateModelSuccessAction(ModuleConfiguration.moduleName, SupportTicketInformationModel, "supportTicketEmailAddress", { key: action.payload.key, model: response.model, control: action.payload.control });
      }));

  @Effect()
  reviseDraftMessageToUsers$: Observable<Action> = this.actions$.ofType(workspaceActions.updateModelType(ModuleConfiguration.moduleName, SupportTicketInformationModel, 'draftMessageToUsersDescription'))
      .switchMap((action: workspaceActions.UpdateModelAction<SupportTicketInformationModel, string>) => this.supportTicketService.reviseDraftMessageToUsers(action.payload.key, action.payload.model)
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<string>(error)))
      .map((response: ModelResponse<string>) => {
        if (response.hasError) {
          return new workspaceActions.UpdateModelErrorAction(
            {
              action: action,
              errors: response.messages.filter(m => m.type === ResponseMessageType.Error).map(m => m.value)
            });
        }
        return new workspaceActions.UpdateModelSuccessAction(ModuleConfiguration.moduleName, SupportTicketInformationModel, "draftMessageToUsersDescription", { key: action.payload.key, model: response.model, control: action.payload.control });
      }));

  @Effect()
  activateMessageToUsers$: Observable<Action> = this.actions$.ofType(supportTicketActions.ACTIVATE_DRAFT_MESSAGE_TO_USERS_ACTION)
      .switchMap((a: ActivateDraftMessageToUsersAction) => this.supportTicketService.activateDraftMessageToUsers()
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<string>(error)))
      .map((response: ModelResponse<string>) => {
        if (response.hasError) {
          return new dashboardActions.TileErrorsAction(ModuleConfiguration.moduleName, SupportTicketInformationModel, { errors: response.messages.map(m => m.value) });
        }
        return new supportTicketActions.ActivateDraftMessageToUsersSuccessAction({ activatedMessageToUsers: response.model });
      }));

  @Effect()
  submitSupportTicket$: Observable<Action> = this.actions$.ofType(supportTicketActions.SUBMIT_SUPPORT_TICKET_ACTION)
      .switchMap((action: supportTicketActions.SubmitSupportTicketAction) => this.supportTicketService.submitSupportTicket(action.payload.model)
        .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<string>(error)))
        .map((response: ModelResponse<string>) => {
        if (response.hasError) {
          return new ActionError(action, response.messages.map(m => m.value));
        }
          return new supportTicketActions.SubmitSupportTicketSuccessAction();
      }));

  constructor(
    private supportTicketService: SupportTicketService,
    private actions$: Actions
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/security/services/SupportTicketService.effects.ts